import { sourceHasValidMedia } from "~components/shared/media/";
import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentOpinion2Up";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    if (!items?.length || items.length < 2) {
        return [
            "The LineupContentOpinion2Up module requires at least two stories.",
        ];
    }

    const filteredItems = items?.filter((item) =>
        sourceHasValidMedia(item, MEDIA_PRIORITY)
    );

    if (!filteredItems?.length) {
        return [
            `This LineupContentOpinion2Up requires at least two stories WITH valid media. (${MEDIA_PRIORITY})`,
        ];
    }

    return checkItemArrayIntegrity(filteredItems, ["headline"]);
}
